/* tslint:disable */

declare var Object: any;
export interface ERPsalesPrepaymentInvoiceInterface {
  "id"?: number;
}

export class ERPsalesPrepaymentInvoice implements ERPsalesPrepaymentInvoiceInterface {
  "id": number;
  constructor(data?: ERPsalesPrepaymentInvoiceInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ERPsalesPrepaymentInvoice`.
   */
  public static getModelName() {
    return "ERPsalesPrepaymentInvoice";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ERPsalesPrepaymentInvoice for dynamic purposes.
  **/
  public static factory(data: ERPsalesPrepaymentInvoiceInterface): ERPsalesPrepaymentInvoice{
    return new ERPsalesPrepaymentInvoice(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ERPsalesPrepaymentInvoice',
      plural: 'ERPsalesPrepaymentInvoices',
      path: 'ERPsalesPrepaymentInvoices',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ERPsalesPrepaymentInvoice.ts